<template>
  <div>
    <div class="row">
      <div class="w-100 px-2">
        <div class="row">
          <div
            class="col-12 mb-3 mb-md-0"
            :class="
              filterOptions.tags.length
                ? 'col-md-5 col-lg-7'
                : 'col-md-2 col-lg-9'
            "
          >
            <validation-provider v-slot="{ errors }">
              <custom-input
                v-model="model.name"
                custom-error-msg="El nombre es requerido."
                :error="errors[0]"
                left-icon
                placeholder="Búsqueda de informes"
                icon="fa fa-search text-orange"
              />
            </validation-provider>
          </div>
          <div class="col-12 mb-3 mb-md-0 col-md-3 col-lg-2">
            <validation-provider v-slot="{ errors }">
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :options="filterOptions.topics"
                placeholder="Tópico"
                v-model="model.topic"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div
            class="col-12 mb-3 mb-md-0 d-flex"
            :class="[
              filterOptions.tags.length
                ? 'col-lg-3 col-md-4'
                : 'col-lg-1 col-md-3 d-flex justify-content-end',
              isMobile && 'custom-grid',
            ]"
          >
            <validation-provider
              v-slot="{ errors }"
              class="w-100 mr-3"
              v-if="filterOptions.tags.length"
            >
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :options="filterOptions.tags"
                placeholder="Etiqueta"
                v-model="model.tag"
                :error="errors[0]"
              />
            </validation-provider>
            <div
              class="d-flex justify-content-md-end justify-content-sm-start btn-search-wrapper"
              :class="isMobile && 'btn-width'"
            >
              <action-button
                @click="$emit('search')"
                i="fa fa-search"
                class="col-sm"
                variant="success"
                id="btn-search"
                :text="isMobile ? 'Buscar' : ''"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import CustomInput from '@/components/common/form/CustomInput'
import CustomDropDown from 'custom-drop-down'
import ActionButton from 'ActionButton'
export default {
  name: 'FilterManager',
  components: {
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    filterOptions() {
      return this.options || {}
    },
  },
}
</script>

<style scoped lang="scss">
.custom-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  grid-template-rows: repeat(2, 1fr) !important;
  grid-column-gap: 0px !important;
  grid-row-gap: 0px !important;
}

.btn-search-wrapper {
  width: 40px;
  height: 40px;
}

.btn-width {
  width: 100%;
}

@media (min-width: 768px) and (max-width: 991px) {
  .btn-width {
    width: 32%;
    margin-left: 1rem;
  }
  .custom-grid {
    grid-template-columns: 1fr 1fr !important;
    grid-template-rows: 1fr !important;
  }
}
</style>
